import axios from 'axios'
import store from '../store'
import analysis from './analysis'
import router from './router'

export default {
  ...analysis,
  ...router,
  /**
   * 设置网站基本信息
   * @param {Object} info
   * @param {String} info.title 网页 title
   * @param {String} info.keywords 网页关键字
   * @param {String} info.desc 网页描述
   */
  setWebsiteBaseInfo: ({ title, keywords, desc }) => {
    // title
    document.title = title
    // keywords
    let keywordsMetaTag = document.createElement('meta')
    keywordsMetaTag.name = 'keywords'
    keywordsMetaTag.content = keywords
    document.getElementsByTagName('head')[0].appendChild(keywordsMetaTag)
    // description
    // let descriptionMetaTag = document.createElement('meta')
    // descriptionMetaTag.name = 'description'
    // descriptionMetaTag.content = desc
    // document.getElementsByTagName('head')[0].appendChild(descriptionMetaTag)
  },
  /**
   * 微信分享设置
   */
  initWxConfig () {
    return new Promise((resolve, reject) => {
      if (!this.isInWeixin()) {
        resolve()
        return
      }
      let url = window.location.href
      // axios.get(`http://wxmisc.geekbang.org/serv/wxshare/sign?url=${encodeURIComponent(url)}`)
      axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`)
        .then(res => {
          if (res.data.code === 0) {
            if (!window.wx) return
            window.wx.config({
              debug: false,
              appId: res.data.data.appId,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.nonceStr,
              signature: res.data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
            })
          }
          resolve()
        })
        .catch(err => { reject(err) })
    })
  },
  /**
   * 微信分享
   */
  weixinshare (option) {
    if (!option && typeof option !== 'object') option = {}
    let { title, imgUrl, desc } = option
    if (!store.state.config) return
    if (!title) title = store.state.config.wechat_share.front_page_title
    if (!imgUrl) imgUrl = store.state.config.wechat_share.default_logo
    if (!desc) desc = store.state.config.wechat_share.default_desp
    if (!window.wx) return
    window.wx.ready(function () {
      window.wx.onMenuShareTimeline({
        title,
        imgUrl,
        link: window.location.href,
        success: function () {},
        cancel: function () {}
      })
      window.wx.onMenuShareAppMessage({
        title,
        desc,
        imgUrl,
        link: window.location.href,
        type: 'link',
        dataUrl: '',
        success: () => {},
        cancel: () => {}
      })
    })
  },
  /**
   * 是否是微信浏览器内
   *
   * @return   {boolean} 如果是微信环境则返回 true
   */
  isInWeixin: () => {
    const ua = window.navigator.userAgent
    return !!ua.match(/MicroMessenger/i)
  },
  /**
   * 是否是 iOS 浏览器内
   *
   * @return   {boolean} 如果是 iOS 环境则返回 true
   */
  isIOS: () => {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  /**
   * 数据按照指定比例展示
   * @param [*] arrData 数据
   * @param [*] arrRatio 数据对应的概率
   */
  randomFn: function random (arrData, arrRatio) {
    let sum = 0
    let factor = 0
    let randomData = Math.random()

    for (var i = arrRatio.length - 1; i >= 0; i--) {
      sum += arrRatio[i] // 统计概率总和
    }
    randomData *= sum // 生成概率随机数
    for (var j = arrRatio.length - 1; j >= 0; j--) {
      if (arrRatio[j]) {
        factor += arrRatio[j]
        if (randomData <= factor) return arrData[j]
      }
    }
    // 兼容概率都为 0 的情况
    if (!factor) {
      return arrData[0]
    } else {
      return {}
    }
  }
}
